import { Box, Shimmer } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"

import { Container } from "./article-card"

const ArticleCardLoading = ({ featured }) => (
  <Container>
    <Shimmer pb={{ _: "65.89%", tablet: "40.32%" }} width="100%" />
    <Box>
      <Shimmer
        height={{ _: "22px", tablet: featured ? "30px" : "22px" }}
        mb={{ _: "10px", tablet: featured ? 3 : "10px" }}
        width="100%"
      />
      <Shimmer height={featured ? "22px" : "66px"} mb={2} width="100%" />
      <Shimmer height="21px" width="66px" />
    </Box>
  </Container>
)

ArticleCardLoading.propTypes = {
  featured: PropTypes.bool,
}

export default ArticleCardLoading
